module.exports = __webpack_public_path__ + "img/default-audio.64b500d7.png";